import { FC } from 'react';
import type { NotificationType } from 'types/notificationRedirect';

const parseNumber = (value?: string | string[]) => (value ? Number(value) : undefined);

export const redirectMap: Record<
  NotificationType['type'],
  (params: Record<string, string | string[]>) => string
> = {
  HIRING_APPLICATION_NEW: (params) => `/responses/${parseNumber(params.VACANCY_ID)}`,

  HIRING_APPLICATION_REJECTED: (params) =>
    `/responses/${parseNumber(params.VACANCY_ID)}?status=rejected&from=${params.type}`,

  HIRING_PROPOSAL_NEW: (params) => `/profile?page=feedbacks&proposal=${parseNumber(params.CV_ID)}`,

  HIRING_PROPOSAL_REJECTED: (params) =>
    `/profile?page=feedbacks&proposal=${parseNumber(params.PROPOSAL_ID)}&status=rejected&from=${params.type}`,

  ACCOUNT_VERIFICATION: (params) => `/auth/verify?code=${params.CODE}`,

  ACCOUNT_REGISTRATION: () => '/registration',

  ACCOUNT_FORGOT: (params) => `/auth/recover?code=${params.CODE}`,

  ACCOUNT_EMAIL_CHANGED: () => '/settings',

  ACCOUNT_PASSWORD_CHANGED: () => '/settings/password?status=changed',

  ACCOUNT_BLOCKED: () => '/blocked',

  ACCOUNT_UN_BLOCKED: () => '/unblocked',

  CHAT_NEW_MESSAGE: (params) => `/messenger?chat=${parseNumber(params.CHAT_ID)}`,
};

// required for next.js building
const DumbComponent = (): FC => null;

export default DumbComponent;
